import styled from 'styled-components';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import { actionButtonStyles } from '@westwing/ui-kit/ActionButton';

const StyledActionButton = styled.button`
    ${actionButtonStyles}
    line-height: initial;
    cursor: pointer;
    background: ${({ theme }) => theme.colors.charcoal100};
    border-color: ${({ theme }) => theme.colors.charcoal100};

    &:hover:not(:disabled) {
        background: ${({ theme }) => theme.colors.charcoal80};
        border-color: ${({ theme }) => theme.colors.charcoal80};
    }

    ${forTablet`
        width: min(335px, 100%);
    `}
`;

export default StyledActionButton;
